<template>
  <div>
    <!-- Modal de edição -->
    <b-modal
      id="email-bi-edit-modal"
      title="Editar e-mail de visualização do BI"
      hide-footer
    >
      <form @submit.prevent="atualizarEmailBi(item)">
        <div class="row">
          <form-input
            :required="true"
            v-model="item.email"
            label="E-mail"
            grid="12"
          />

          <form-input
            v-model="item.descricao"
            label="Descrição"
            grid="12"
          />

          <div class="col-md-12">
            <label>Status</label>
            <select class="form-control" v-model="item.habilitado">
              <option :value="true">Ativo</option>
              <option :value="false">Inativo</option>
            </select>
          </div>

          <div class="col-md-12 mt-3 text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="$bvModal.hide('email-bi-edit-modal')"
            >
              Cancelar
            </button>

            <button
              type="submit"
              class="btn btn-success btn-sm btn-submit-edit-email-bi"
              data-style="zoom-in"
            >
              Salvar
              <i class="mdi mdi-content-save" />
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <div class="col-12 px-0">
      <div class="d-flex align-items-center justify-content-between mb-0">
        <div>
          <h5 class="font-weight-bold">
            E-mails de visualizações dos gráficos (BI)
          </h5>
        </div>

        <div>
          <div class="input-group mb-3">
            <b-input
              :placeholder="$t('Type to search')"
              class="form-control search-input"
              type="search"
              v-model="search"
              aria-describedby="input-search"
              v-on:change="getEmailsBi"
            />

            <div class="input-group-append" role="button">
              <span class="input-group-text" id="input-search">
                <i class="fas fa-search search-icon" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário de cadastro -->
    <form @submit.prevent="inserirEmailBi">
      <div class="row">
        <form-input
          :required="true"
          v-model="email"
          label="E-mail"
          grid="4"
        />

        <form-input
          v-model="descricao"
          label="Descrição"
          grid="4"
        />

        <div class="col-md-2">
          <label>Status</label>
          <select class="form-control" v-model="habilitado">
            <option :value="true">Ativo</option>
            <option :value="false">Inativo</option>
          </select>
        </div>

        <div class="col-md-2 pl-0">
          <button
            class="btn btn-block btn-submit-emails-bi btn-success btn-sm mt-4"
            data-style="zoom-in"
            type="submit"
          >
            {{ $t("Cadastrar") }}
            <i class="mdi mdi-content-save" />
          </button>
        </div>
      </div>
    </form>

    <div class="row">
      <div class="col-12">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />

        <b-table
          :fields="[
            {
              key: 'id',
              label: $t('ID'),
              thStyle: { width: '50px', minWidth: '50px' },
            },
            {
              key: 'email',
              label: $t('E-mail'),
            },
            {
              key: 'descricao',
              label: $t('Descrição'),
            },
            {
              key: 'habilitado',
              label: $t('Status'),
            },
            {
              key: 'actions',
              label: '',
              class: 'text-right',
              thStyle: { width: '140px', minWidth: '140px' },
            },
          ]"
          :items="emailsBi"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>

          <template v-slot:cell(email)="data">
            {{ data.item.email }}
          </template>

          <template v-slot:cell(descricao)="data">
            {{ data.item.descricao }}
          </template>

          <template v-slot:cell(habilitado)="data">
            <strong
              :style="`color: ${data.item.habilitado ? '#28a745' : '#dc3545'}`"
            >
              {{ data.item.habilitado ? "Ativo" : "Inativo" }}
            </strong>
          </template>

          <template v-slot:cell(actions)="data">
            <b-button
              :title="$t('Editar')"
              class="px-2 mb-0 mr-1"
              size="xs"
              type="button"
              v-b-tooltip.hover
              variant="success"
              @click="abrirModalEditar(data.item)"
            >
              <i class="mdi mdi-square-edit-outline" />
            </b-button>

            <b-button
              :title="$t('Excluir')"
              class="px-2 mb-0"
              size="xs"
              type="button"
              v-b-tooltip.hover
              variant="danger"
              @click="excluirEmailBi(data.item)"
            >
              <i class="mdi mdi-delete" />
            </b-button>
          </template>

          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />

              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                @change="getEmailsBi"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>

            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>

          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }} {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PainelGestor",

  data() {
    return {
      emailsBi: [],

      email: null,
      descricao: null,
      habilitado: true,

      page: 1,
      search: "",
      perPage: 10,
      loading: false,

      item: {
        id: null,
        email: null,
        descricao: null,
        habilitado: true,
      },

      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },

  mounted() {
    this.getEmailsBi();
  },

  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getEmailsBi();
      }
    },

    getEmailsBi() {
      this.loading = true;

      axios
        .get(
          `api/dashboard/emails-bi?page=${this.page}&perPage=${this.perPage}&search=${encodeURIComponent(this.search)}`
        )
        .then((response) => {
          this.emailsBi = response.data.data;
          this.pagination = response.data.pagination;

          if (
            this.pagination.totalPages < this.pagination.currentPage &&
            this.pagination.totalPages > 0
          ) {
            this.page = this.pagination.totalPages;
            this.getEmailsBi();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;

          this.$snack.danger({
            button: false,
            text: "Erro ao buscar os e-mails.",
          });
        });
    },

    async inserirEmailBi() {
      let ladda = Ladda.create(
        document.querySelector(".btn-submit-emails-bi")
      );

      ladda.start();
      this.loading = true;

      await axios
        .post("api/dashboard/emails-bi", {
          email: this.email,
          descricao: this.descricao,
          habilitado: this.habilitado,
        })
        .then((response) => {
          if (response.status === 201) {
            this.getEmailsBi();

            this.$snack.success({
              button: false,
              text: "E-mail cadastrado com sucesso!",
            });

            this.email = null;
            this.descricao = null;
            this.habilitado = true;
          }
        })
        .catch((error) => {
          let mensagem = "Erro ao cadastrar o e-mail.";

          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            mensagem = "Verifique os dados informados.";
          }

          this.$snack.danger({
            button: false,
            text: mensagem,
          });
        });

      this.loading = false;
      ladda.stop();
    },

    abrirModalEditar(registro) {
      this.item = {
        id: registro.id,
        email: registro.email,
        descricao: registro.descricao,
        habilitado: registro.habilitado === true || registro.habilitado === 1 || registro.habilitado === "1",
      };

      this.$bvModal.show("email-bi-edit-modal");
    },

    async atualizarEmailBi(it) {
      let ladda = Ladda.create(
        document.querySelector(".btn-submit-edit-email-bi")
      );

      ladda.start();
      this.loading = true;

      await axios
        .put(`api/dashboard/emails-bi/${it.id}`, {
          email: it.email,
          descricao: it.descricao,
          habilitado: it.habilitado,
        })
        .then((response) => {
          if (response.status === 200) {
            this.getEmailsBi();

            this.$snack.success({
              button: false,
              text: "E-mail atualizado com sucesso!",
            });

            this.$bvModal.hide("email-bi-edit-modal");
          }
        })
        .catch((error) => {
          let mensagem = "Erro ao atualizar o e-mail.";

          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            mensagem = "Verifique os dados informados.";
          }

          this.$snack.danger({
            button: false,
            text: mensagem,
          });
        });

      this.loading = false;
      ladda.stop();
    },

    async excluirEmailBi(registro) {
      if (!confirm(`Deseja realmente excluir o e-mail ${registro.email}?`)) {
        return;
      }

      this.loading = true;

      await axios
        .delete(`api/dashboard/emails-bi/${registro.id}`)
        .then((response) => {
          if (response.status === 200) {
            this.getEmailsBi();

            this.$snack.success({
              button: false,
              text: "E-mail excluído com sucesso!",
            });
          }
        })
        .catch(() => {
          this.$snack.danger({
            button: false,
            text: "Erro ao excluir o e-mail.",
          });
        });

      this.loading = false;
    },
  },
};
</script>